import { library } from '@fortawesome/fontawesome-svg-core';
const fontAwesome = { library };
import { default as Icon } from './Icon';

export { fontAwesome, Icon };
export * from './types';
